import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useMessaging } from "@/context/MessagingContext";
import { ConversationList } from "@/components/messaging/ConversationList";
import { ChatThread } from "@/components/messaging/ChatThread";
import { NewConversationDialog } from "@/components/messaging/NewConversationDialog";
import { Button } from "@/components/ui/button";
import { MessageCircle, X, ChevronLeft, Plus } from "lucide-react";

export const ChatDock = () => {
  const location = useLocation();
  const { conversations, unreadTotal, activeId, active, openConversation, closeConversation, loadConversations } = useMessaging();
  const [open, setOpen] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const openDock = () => { setOpen(true); loadConversations(); };

  // The full Messages page already provides this experience.
  if (location.pathname.startsWith("/app/messages")) return null;

  return (
    <>
      {!open && (
        <button onClick={openDock} data-testid="chat-dock-button"
          className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-xl transition-transform hover:scale-105">
          <MessageCircle className="h-6 w-6" />
          {unreadTotal > 0 && (
            <span data-testid="chat-dock-unread" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-white">{unreadTotal}</span>
          )}
        </button>
      )}

      {open && (
        <div className="fixed bottom-6 right-6 z-50 flex h-[560px] w-[360px] max-w-[calc(100vw-2rem)] flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-2xl" data-testid="chat-dock-panel">
          <div className="flex items-center justify-between border-b border-border px-4 py-3">
            <div className="flex items-center gap-2">
              {activeId && <button onClick={closeConversation} data-testid="chat-dock-back" className="text-muted-foreground hover:text-foreground"><ChevronLeft className="h-5 w-5" /></button>}
              <span className="font-heading text-sm font-semibold">{activeId ? active?.title : "Messages"}</span>
            </div>
            <div className="flex items-center gap-1">
              {!activeId && <Button size="icon" variant="ghost" onClick={() => setShowNew(true)} data-testid="chat-dock-new"><Plus className="h-4 w-4" /></Button>}
              <Button size="icon" variant="ghost" onClick={() => setOpen(false)} data-testid="chat-dock-close"><X className="h-4 w-4" /></Button>
            </div>
          </div>
          <div className="flex-1 overflow-hidden">
            {activeId ? <ChatThread compact /> : (
              <div className="h-full overflow-y-auto"><ConversationList conversations={conversations} activeId={activeId} onSelect={openConversation} /></div>
            )}
          </div>
        </div>
      )}

      <NewConversationDialog open={showNew} onClose={() => setShowNew(false)} />
    </>
  );
};
